import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSourceforgeComponent } from './simple-icons-sourceforge.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSourceforgeComponent ],
    exports:      [ SimpleIconsSourceforgeComponent ],
    bootstrap:    []
})
export class SimpleIconsSourceforgeModule {}
